import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _map from 'lodash/map';
import SVG from 'react-inlinesvg';
import calendarIcon from '@lifesize/ux-assets/vectors/svgIcons/calendar.svg';
import CalendarDay from 'containers/CalendarDay/CalendarDayContainer';
import Button from 'components/Button/Button';
import CalendarRefresh from 'containers/CalendarRefresh/CalendarRefreshContainer';
import CalendarMeetingView from 'containers/CalendarMeetingView/CalendarMeetingView';
import contactClasses from 'components/Contacts/Contacts.module.scss';
import classes from './Upcoming.module.scss';
import SyncCalendar from 'components/SyncCalendar/SyncCalendar';

export const Upcoming = (props) => {
  const { openScheduleModal, hasSelectedEvent, noSyncedCalendars, days, isRefreshing } = props;

  return (
    <div className={contactClasses.contactsContainer} id="upcomingContainer">
      <div className={contactClasses.leftContainer}>
        <div className={[contactClasses.contactsHeader, classes.header].join(' ')}>
          <header>
            <div className={contactClasses.headerIconContainer}>
              <SVG src={calendarIcon} />
            </div>
            <h3>
              <FormattedMessage id="components.upcoming.header" defaultMessage="Upcoming Meetings" />
            </h3>
            <div className={classes.actionBar}>
              {noSyncedCalendars ? <div style={{ minWidth: '131px' }} /> : <CalendarRefresh />}
              <Button
                onClick={openScheduleModal}
                kind="primary"
                className={classes.scheduleButton}
                dataAttrs={{ 'data-testid': 'upcoming-schedule-btn' }}
              >
                <FormattedMessage
                  id="components.upcoming.schedule"
                  defaultMessage="Schedule"
                />
              </Button>
            </div>
          </header>
        </div>
        <div
          className={[
            contactClasses.contactsListContainer,
            classes.eventsContainer,
            isRefreshing ? classes.refreshing : ''
          ].join(' ')}
        >
          {noSyncedCalendars ?
            <SyncCalendar />
            :
            _map(days, (day, index) => <CalendarDay day={index} key={index} />)
          }
        </div>
      </div>
      {hasSelectedEvent && <CalendarMeetingView />}
    </div>
  );
};

Upcoming.propTypes = {
  days: PT.array,
  hasSelectedEvent: PT.bool,
  isRefreshing: PT.bool,
  noSyncedCalendars: PT.bool,
  openScheduleModal: PT.func
};

export default Upcoming;
